import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import styles from './index.styl';

const ProgressBar = ({ progress = 0 }) => {
  return (
    <div styleName="root" className="black-05">
      <div styleName="root-line" style={{ width: `${progress}%` }} />
    </div>
  );
};

ProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
};

export default CSSModules(ProgressBar, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/ProgressBar/index.jsx